var map = {
	"./client-01.svg": 54696,
	"./client-02.svg": 86587,
	"./client-03.svg": 17770,
	"./client-04.svg": 46869,
	"./client-05.svg": 8884,
	"./client-06.svg": 73447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65715;